import { toast } from "react-toastify";
import { ACCESSACTION } from "../../routes/accessActions";
import CryptoJS from "crypto-js";

const secret = process.env.REACT_APP_SECRET || "sfdsfasdfsdf3434$$$";
const decryptToken = (token: string, secret: string): string | undefined => {
  try {
    return CryptoJS.AES.decrypt(token, secret).toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Error decrypting token:", error);
    return undefined;
  }
};
const accessPermission: string | null =
  localStorage.getItem("accessPermission");
const decryptedAccessPermission = accessPermission
  ? decryptToken(accessPermission, secret)
  : undefined;
let accessActions: number[] | undefined;
if (decryptedAccessPermission) {
  try {
    accessActions = decryptedAccessPermission.split(",").map(Number);
  } catch (error) {
    console.error("Error parsing accessPermission:", error);
  }
}
export const restrict = () => {
  for (const key of Object.keys(ACCESSACTION)) {
    const action = ACCESSACTION[key];
    if (accessActions?.includes(action?.KEY)) {
      toast.error(
        `You don't have permission to ${action.NAME}. Contact super admin.`
      );
      return true; // Block triggered
    }
  }
  return false; // No restriction
};

